export class TvAccountActivityData {
    public openGrossPL: number = 0;
    public openNetPL: number = 0;
    public openPositionsCount: number = 0;
    public openOrdersCount: number = 0;
}
